import React from 'react';
import { Card } from 'react-bootstrap';
import { Pie } from 'react-chartjs-2';
import { ProgressByOwner } from './ProgressByOwner';

interface Props {
  departmentStats: any;
}

export const PieChart = (props: Props) => {
  const [isPaneOpen, setIsPaneOpen] = React.useState(false);
  const [progressByOwnerDept, setProgressByOwnerDept] = React.useState(null);

  const showProgressByOwner = (departmentId) => {
    setIsPaneOpen(true);
    setProgressByOwnerDept(departmentId);
  };

  return (
    <div onClick={() => !isPaneOpen && showProgressByOwner(props.departmentStats.id)}>
      <Card className='grid-card'>
        <Card.Header>
          {props.departmentStats.name} ({props.departmentStats.abbreviation})
        </Card.Header>
        <Card.Body>
          <Card.Subtitle className='text-muted'>
            <span className='float-left'>Total Items: {props.departmentStats.total}</span>
            <span className='float-right'>{props.departmentStats.percentDone}% Complete</span>
          </Card.Subtitle>
          <Pie
            data={{
              labels: ['Unscanned Items', 'Scanned Items'],
              datasets: [
                {
                  label: 'Scanned',
                  data: [props.departmentStats.needScan, props.departmentStats.scanned],
                  backgroundColor: ['#F39C12', '#00bc8c'],
                },
              ],
            }}
            options={{
              maintainAspectRatio: true,
              responsive: true,
              legend: { display: false },
            }}
          />
        </Card.Body>
      </Card>
      <ProgressByOwner departmentId={progressByOwnerDept} isOpen={isPaneOpen} toggleOpen={() => setIsPaneOpen(false)} />
    </div>
  );
};
